import Grid from "components/Grid";
import Text from "components/Text";
import { ReactComponent as AgencyIcon } from "icons/agency.svg";
import { ReactComponent as AgencyActiveIcon } from "icons/agency_active.svg";
import { ReactComponent as TalentIcon } from "icons/talent.svg";
import { ReactComponent as TalentActiveIcon } from "icons/talent_active.svg";
import { FC } from "react";
import { BiArrowBack } from "react-icons/bi";
import theme from "theme";
import { DescribeYourselfProps } from "../types";
import { StyledButton, UserTypeCard } from "./DescribeYourself.styled";

export const DescribeYourself: FC<DescribeYourselfProps> = ({
    userType,
    handleDone,
    isLoading,
    handleUserTypeChange,
    handleBack,
}) => {
    return (
        <>
            <Text variant="heading5" align="center" fullWidth>
                Sign Up
            </Text>
            <Grid row columnGap={2}>
                <UserTypeCard
                    isActive={userType === "talent"}
                    onClick={() => handleUserTypeChange("talent")}
                >
                    {userType === "talent" ? (
                        <TalentActiveIcon />
                    ) : (
                        <TalentIcon />
                    )}
                    <Text
                        variant="body1"
                        color={theme.colors.grey.secondary}
                        align="center"
                    >
                        I'm a <br />
                        <Text
                            variant="body1"
                            fontWeight="600"
                            color={
                                userType === "talent"
                                    ? theme.colors.text
                                    : "#7B7187"
                            }
                        >
                            Talent
                        </Text>
                    </Text>
                </UserTypeCard>
                <UserTypeCard
                    isActive={userType === "agency"}
                    onClick={() => handleUserTypeChange("agency")}
                >
                    {userType === "agency" ? (
                        <AgencyActiveIcon />
                    ) : (
                        <AgencyIcon />
                    )}
                    <Text
                        variant="body1"
                        color={theme.colors.grey.secondary}
                        align="center"
                    >
                        I'm an <br />
                        <Text
                            variant="body1"
                            fontWeight="600"
                            color={
                                userType === "agency"
                                    ? theme.colors.text
                                    : "#7B7187"
                            }
                        >
                            Agency
                        </Text>
                    </Text>
                </UserTypeCard>
            </Grid>
            <Grid row columnGap={1} marginTop={2}>
                <StyledButton
                    variant="outlined"
                    onClick={handleBack}
                    icon={<BiArrowBack />}
                    iconPosition="prefix"
                    width={114}
                >
                    Back
                </StyledButton>
                <StyledButton
                    isLoading={isLoading}
                    variant="filled"
                    onClick={handleDone}
                >
                    Sign up
                </StyledButton>
            </Grid>
        </>
    );
};
